import { useAccent } from "@/ui";
import { SERP_REGIONS } from "./serpData";

interface ProgressDotsProps {
  visited: ReadonlySet<number>;
  selected: number | null;
  onSelect: (index: number) => void;
}

/** Nine visited-state dots above the mock — doubles as a region jump bar. */
export function ProgressDots({ visited, selected, onSelect }: ProgressDotsProps) {
  const [from, to] = useAccent();
  return (
    <div className="flex items-center gap-2.5 pl-1">
      {SERP_REGIONS.map((region, i) => {
        const isSelected = selected === i;
        const isVisited = visited.has(i);
        return (
          <button
            key={region.id}
            type="button"
            aria-label={`Go to region ${region.n}: ${region.name}`}
            onClick={() => onSelect(i)}
            className={`h-3.5 w-3.5 rounded-full transition-all duration-300 ${
              isSelected ? "scale-125" : "hover:scale-110"
            }`}
            style={{
              background:
                isSelected || isVisited
                  ? `linear-gradient(135deg, ${from}, ${to})`
                  : "rgba(255,255,255,0.14)",
              border:
                isSelected || isVisited ? "none" : "1px solid rgba(255,255,255,0.28)",
              boxShadow: isSelected ? `0 0 14px ${from}` : "none",
            }}
          />
        );
      })}
      <span className="ml-3 text-xl text-white/50">
        {visited.size} / {SERP_REGIONS.length} explored
      </span>
      <span className="ml-auto font-mono text-xl text-white/40">[ ] cycle regions</span>
    </div>
  );
}
